import AuthService from '@/services/auth.service';
import router, { resetRouter } from '@/router';
import store from '@/store';

/* eslint-disable no-shadow */
const user = JSON.parse(localStorage.getItem('user'));
const state = {
    status: {
        loggedIn: Boolean(user),
    },
    user: user,
    roles: []
};

export default {
    namespaced: true,
    state: state,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        getInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                if (!state.user) {
                    reject('Verification failed, please Login again.');
                }

                const { roles, name, avatar, introduction } = state.user;
                // roles must be a non-empty array
                if (!roles || roles.length <= 0) {
                    reject('getInfo: roles must be a non-null array!');
                }

                commit('setRoles', roles);
                // commit('SET_NAME', name)
                // commit('SET_AVATAR', avatar)
                // commit('SET_INTRODUCTION', introduction)
                resolve(state.user);
            });
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        loginSuccess(state, logUser) {
            state.status.loggedIn = true;
            state.user = logUser;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.roles = null;
        },
        setRoles(state, roles) {
            state.roles = roles;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.roles = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        }
    }
};
/* eslint-enable no-shadow */
